export default __webpack_public_path__ + "static/media/img-industrial-operator.bcad49a3.svg";